import { render, staticRenderFns } from "./bank-link-pending.vue?vue&type=template&id=71fb63b4&scoped=true&"
import script from "./bank-link-pending.vue?vue&type=script&lang=js&"
export * from "./bank-link-pending.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71fb63b4",
  null
  
)

export default component.exports